import { useState, useMemo, useEffect } from 'react';
import CartClient from 'clients/cart';
import { getCountryCode, getLanguageCode } from 'utilities/locales';
import {
  eligibleProductPromotions,
  getTopPromoEligibility,
} from 'components/pages/product/helpers';

export const usePromotionEligibility = (cart, currentProduct) => {
  const [promoEligibility, setPromoEligibility] = useState([]);
  const { number: cartNumber } = cart;
  const countryCode = getCountryCode();
  const languageCode = getLanguageCode();

  const cartClient = useMemo(
    () => new CartClient(cartNumber, countryCode, languageCode),
    [],
  );

  const promotionEligibility = () => {
    const promosByPriority = eligibleProductPromotions(currentProduct.slug);

    getTopPromoEligibility(promosByPriority, cartClient, (eligibility) => {
      eligibility && setPromoEligibility(eligibility);
    });
  };

  useEffect(() => promotionEligibility(), [currentProduct]);

  return { promoEligibility };
};
